const norm=text=>String(text||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").trim().toLowerCase().replace(/\s+/g," ");
export const siteFields={
 "nome do site":{path:["identity","brand_name"],label:"Nome do site"},
 "subtitulo da marca":{path:["identity","brand_subtitle"],label:"Subtítulo da marca"},
 "titulo do painel":{path:["admin","title"],label:"Título do painel administrativo"},
 "texto do rodape":{path:["footer","line"],label:"Texto do rodapé"},
 "botao ver catalogo":{path:["header","catalog_button"],label:"Botão Ver catálogo"},
 "botao minha conta":{path:["header","account_label"],label:"Botão Minha conta"}
};
export function parseSafeAssistantCommand(raw){
 const text=String(raw||"").trim().replace(/\s+/g," ").replace(/^(?:(?:boa noite|bom dia|boa tarde|ol[aá]|oi|tudo bem)[!.,?()\s]*)+/i,"").trim();
 const prefix=/^(?:(?:por favor|pode|poderia|consegue|voce consegue|voce pode|preciso que|quero que|gostaria que)[,!?\s]*)*(?:altere|alterar|mude|mudar|troque|trocar|coloque|colocar|defina|definir|atualize|atualizar)\s+/i;
 if(!prefix.test(text))return null;
 const body=text.replace(prefix,"").trim();
 let match=body.match(/^(?:o |a )?(.+?)\s+(?:para|como)\s+(.+)$/i);
 if(!match)return null;
 const target=norm(match[1]),value=match[2].trim();
 if(!value||value.length>160||/\b(?:e altere|e mude|e apague)\b/i.test(value))return {error:"Envie uma alteração por vez, com texto de até 160 caracteres."};
 if(target==="nome do grupo"||target==="nome da plataforma")return {type:"site",...siteFields["nome do site"],value};
 if(siteFields[target])return {type:"site",...siteFields[target],value};
 const priceTarget=norm(match[1]);
 const priceMatch=priceTarget.match(/^preco\s+(por frasco|do box)\s+(?:do produto\s+)?(.+)$/);
 if(priceMatch){
  const box=priceMatch[1]==="do box";
  const numbers=value.replace(/^r\$\s*/i,"").replace(/\s/g,"");
  const money=numbers.includes(",")?Number(numbers.replace(/\./g,"").replace(",",".")):Number(numbers);
  if(!Number.isFinite(money)||money<=0||money>100000)return {error:"Informe um preço positivo, por frasco ou por BOX."};
  return {type:"price",productName:priceMatch[2],unit:box?"box":"frasco",value:Math.round(money*100)/100};
 }
 if(priceTarget.startsWith("preco"))return {error:"Especifique 'preço por frasco do produto ...' ou 'preço do BOX do produto ...'."};
 return null;
}
export const sameText=(a,b)=>norm(a)===norm(b);
export const fieldValue=(config,path)=>path.reduce((acc,key)=>acc?.[key],config);
export const patchField=(config,path,value)=>{
 const copy=JSON.parse(JSON.stringify(config));
 let cursor=copy;for(let i=0;i<path.length-1;i++){cursor[path[i]]??={};cursor=cursor[path[i]];}
 cursor[path[path.length-1]]=value;return copy;
};
